import './cadastro.css';
import { AxiosError } from 'axios';
import api from '../../../services/cle';
import React, { useState, useEffect } from 'react';
import { useAppSelector } from '../../../store/hooks';
import { SubmitHandler, useForm } from 'react-hook-form';
import InputLabel from '../../../rxlib/components/input-label';
import Redirecionar from '../../../rxlib/components/redirecionar';
import { tratarErroApi } from '../../../rxlib/services/utilitarios';
import { usuarioTemPermissao } from '../../../rxlib/services/seguranca';
import AcessoBloqueado from '../../../rxlib/components/acesso-bloqueado';
import ButtonsCrud from '../../../rxlib/components/buttons/buttons-crud';
import { RxlibLayout } from '../../../rxlib/components/layout/rxlib-Layout';
import { ModalWarning } from '../../../rxlib/components/modal/modal-warning';
import Breadcrumb, { BreadcrumbItem } from '../../../rxlib/components/breadcrumb';

import {
    ApiError,
    ParametroOrganizacao,
    ParametroOrganizacaoCadastroProps,
} from '../../../services/tipos';

function ParametroOrganizacaoCadastro(props: ParametroOrganizacaoCadastroProps) {
    const [salvo, setSalvo] = useState<boolean>(false);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [nomeOrganizacao, setNomeOrganizacao] = useState<string>('');

    const [ParametroOrganizacao, setParametroOrganizacao] = useState<ParametroOrganizacao>({
        id: '',
        nome: '',
        valor: '',
        idOrganizacao: '',
    });

    const { register, handleSubmit } = useForm<ParametroOrganizacao>();

    const handleHideWarning = () => setShowWarning(false);

    const breadcrumbs: BreadcrumbItem[] = [
        { texto: 'Home', link: '/home' },
        { texto: 'Organizações e unidades', link: '/organizacao' },
        { texto: 'Parâmetros da organização', link: `/organizacao/parametros/${props.match.params.idorganizacao}` },
        { texto: props.match.params.action ? 'Visualização' : props.match.params.id ? 'Edição' : 'Novo', link: '' },
    ];

    const temPermissao = props.match.params.action
        ? usuarioTemPermissao(token, 'parametros_organizacao_visualizar')
        : props.match.params.id
            ? usuarioTemPermissao(token, 'parametros_organizacao_editar')
            : usuarioTemPermissao(token, 'parametros_organizacao_novo');

    useEffect(() => {
        if (temPermissao) {
            if (props.match.params.id) {
                api.get(`/ParametroOrganizacao/${props.match.params.id}`)
                    .then(response => {
                        setParametroOrganizacao({
                            id: response.data.id,
                            nome: response.data.nome,
                            valor: response.data.valor,
                            idOrganizacao: response.data.idOrganizacao,
                        });
                    }).catch((error: AxiosError<ApiError>) => {
                        tratarErro(error, 'Não foi possível carregar o parâmetro da organização: ');
                    });
            } else {
                setParametroOrganizacao({
                    id: '',
                    nome: '',
                    valor: '',
                    idOrganizacao: props.match.params.idorganizacao,
                });
            }

            api.get(`/Organizacao/${ParametroOrganizacao.idOrganizacao}`)
                .then(response => {
                    setNomeOrganizacao(response.data.nome);
                }).catch((error: AxiosError<ApiError>) => {
                    tratarErro(error, 'Não foi possível carregar a organização: ');
                });
        }
    }, [props.match.params.idorganizacao, props.match.params.id, ParametroOrganizacao.idOrganizacao, temPermissao]);

    const onSubmit: SubmitHandler<ParametroOrganizacao> = data => {
        setCarregando(true);
        props.match.params.id
            ? editar(data)
            : salvar(data);
    }

    function salvar(data: ParametroOrganizacao) {
        api.post('/ParametroOrganizacao', data)
            .then(response => {
                setSalvo(true);
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error, 'Não foi possível salvar o parâmetro da organização: ');
            });
    }

    function editar(data: ParametroOrganizacao) {
        api.put('/ParametroOrganizacao', data)
            .then(response => {
                setSalvo(true);
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error, 'Não foi possível salvar o parâmetro da organização: ');
            });
    }

    function tratarErro(error: AxiosError<ApiError>, mensagem: string) {
        setCarregando(false);
        setMessageWarning(tratarErroApi(error, mensagem));
        setShowWarning(true);
    }

    function isReadOnly(): boolean {
        return (props.match.params.action === 'view');
    }

    return (
        <>
            <RxlibLayout>
                <Breadcrumb
                    itens={breadcrumbs} />
                <form onSubmit={handleSubmit(onSubmit)} className='rxlib-form'>
                    <div className='container-fluid'>
                        <div className='row px-1'>
                            <div className='col-12'>
                                <h6>{props.match.params.action ? 'Visualizar' : props.match.params.id ? 'Editar' : 'Novo'} parâmetros da organização</h6>
                            </div>
                        </div>
                        {
                            props.match.params.id
                                ? <div className='row px-1'>
                                    <div className='col-12 mt-1'>
                                        <InputLabel
                                            name='id'
                                            type='text'
                                            id='inputId'
                                            maxLength={50}
                                            readOnly={true}
                                            label='Código:'
                                            autoFocus={false}
                                            defaultValue={ParametroOrganizacao.id}
                                            referencia={register({ required: true })}
                                            placeholder='Código do parâmetros da organização'
                                            className='rxlib-input-label-linha-parametros-organizacao' />
                                    </div>
                                </div>
                                : ''
                        }
                        <div className='row px-1 d-none'>
                            <div className='col-12 mt-1'>
                                <InputLabel
                                    type='text'
                                    maxLength={50}
                                    readOnly={true}
                                    autoFocus={false}
                                    name='idOrganizacao'
                                    label='idOrganizacao:'
                                    id='inputIdOrganizacao'
                                    placeholder='idOrganizacao'
                                    referencia={register({ required: true })}
                                    defaultValue={ParametroOrganizacao.idOrganizacao}
                                    className='rxlib-input-label-linha-parametros-organizacao' />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <InputLabel
                                    type='text'
                                    maxLength={50}
                                    readOnly={true}
                                    autoFocus={false}
                                    name='organizacao'
                                    label='Organização:'
                                    id='inputOrganizacao'
                                    placeholder='Organização'
                                    defaultValue={nomeOrganizacao}
                                    referencia={React.createRef()}
                                    className='rxlib-input-label-linha-parametros-organizacao' />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <InputLabel
                                    type='text'
                                    maxLength={50}
                                    autoFocus={true}
                                    name='nome'
                                    label='Nome:'
                                    id='inputNome'
                                    placeholder='Nome'
                                    readOnly={isReadOnly()}
                                    referencia={register({ required: true })}
                                    defaultValue={ParametroOrganizacao.nome}
                                    className='rxlib-input-label-linha-parametros-organizacao' />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <InputLabel
                                    type='text'
                                    name='valor'
                                    label='Valor:'
                                    maxLength={50}
                                    id='inputValor'
                                    autoFocus={false}
                                    placeholder='Valor'
                                    readOnly={isReadOnly()}
                                    referencia={register({ required: true })}
                                    defaultValue={ParametroOrganizacao.valor}
                                    className='rxlib-input-label-linha-parametros-organizacao' />
                            </div>
                        </div>
                        <ButtonsCrud
                            carregando={carregando}
                            styleButton='btn-rxlib'
                            visualizar={props.match.params.action === 'view'}
                            linkCancelarVoltar={`/organizacao/parametros/${ParametroOrganizacao.idOrganizacao}`} />
                    </div>
                </form>
                <ModalWarning
                    show={showWarning}
                    message={messageWarning}
                    onHide={handleHideWarning} />
                <AcessoBloqueado
                    permissao={temPermissao} />
                <Redirecionar
                    se={salvo}
                    para={`/organizacao/parametros/${ParametroOrganizacao.idOrganizacao}`} />
            </RxlibLayout>
        </>
    );
}

export default ParametroOrganizacaoCadastro;